import { defineComponent as _defineComponent } from 'vue'
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessItem',
  props: {
    item: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
  item: {
    message: string;
    color: string;
  };
  index: number;
};



function removeSuccess() {
  store.commit('removeSuccess', props.index);
}

function getIconByColorStatus(color = props.item.color) {
  if (color === 'error') return 'mdi-alert-circle';
  return 'mdi-check-circle';
}

return { __sfc: true,props, removeSuccess, getIconByColorStatus }
}

})